// SmallMultiplesGrid.jsx

import React from 'react';
import SmallMultipleCard from './SmallMultipleCard';

const SmallMultiplesGrid = ({ childrenNodes, metricMode, totalNonfarmValues }) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '1rem',
      }}
    >
      {childrenNodes.map((child) => (
        <SmallMultipleCard
          key={child.id}
          node={child}
          metricMode={metricMode}
          totalNonfarmValues={totalNonfarmValues}
        />
      ))}
    </div>
  );
};

export default SmallMultiplesGrid;